export default __webpack_public_path__ + "static/media/underConstruction.bb7729a6.svg";